import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material/styles';
import './App.css';
import MainSite from './sites/main_site';
import AuthProvider from './providers/AuthProvider';
import { ErrorDialogProvider } from './providers/ErrorDialogProvider';
import { deDE } from '@mui/material/locale';

function App() {
  const theme = createTheme({
    palette: {
      type: 'light',
      primary: {
        main: '#15427b',
      },
      secondary: {
        main: '#FFD95A',
      },
      info: {
        main: '#FFD95A',
      },
    },
  }, deDE);

  return (
    <ThemeProvider theme={theme}>
      <ErrorDialogProvider>
        <AuthProvider>
          <MainSite/>
        </AuthProvider>
      </ErrorDialogProvider>
    </ThemeProvider>
  );
}

export default App;